import {menuToggle} from './components/menu';

menuToggle();
